var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"breadcrumbsRef"},[_c('SfBreadcrumbs',{staticClass:"category-breadcrumbs",class:{'moomin-breadcrumbs--pdp': _vm.isProductDetailPage},attrs:{"breadcrumbs":_vm.breadcrumbs,"isOverflowing":_vm.checkOverflow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }